import { useState } from "react";
import { useTheme } from "@mui/material/styles";
import {
    Box,
    Divider,
    FormControl,
    FormHelperText,
    Grid,
    InputLabel,
    OutlinedInput,
} from "@mui/material";

import * as Yup from "yup";
import { Formik } from "formik";
import useScriptRef from "../../../hooks/useScriptRef";
import AnimateButton from "../../../styles/ui-component/extended/AnimateButton";

import { UserApi } from "../../../api/user-management";
import { ResetPasswordByIndRequest} from "../../../api/user-management/models/reset-password-by-ind-request";
import { useRecoilValue } from "recoil";
import { configState } from "../../../recoil/atoms";
import { toast } from "react-toastify";
import {LoadingButton} from "@mui/lab";

const ForgotPassword = ({ setOpenModal, ...others }: any) => {
    const theme = useTheme();
    const scriptedRef = useScriptRef();
    const config = useRecoilValue(configState);

    const [loading, setLoading] = useState<boolean>(false);


    const resetPassword = (values: ResetPasswordByIndRequest) => {
        const user = new UserApi(config);
        user.resetPasswordByUser(values)
            .then((res: any) => {
                setLoading(false);
                setOpenModal(false);
                toast.success(res?.data?.Message!);
            })
            .catch((err) => {
                toast.error(err?.response?.data?.detail);
                setOpenModal(false);
                setLoading(false);
            });
    };

    const handleSubmit = (values: ResetPasswordByIndRequest, actions: any) => {
        if (scriptedRef.current) {
            setLoading(true);
            actions.setStatus({ success: true });
            actions.setSubmitting(false);
            resetPassword(values);
        }
    };

    return (
        <>
            <Grid container direction="column" justifyContent="center" spacing={1}>
                <Grid item xs={12}>
                    <Box
                        sx={{
                            alignItems: "center",
                            display: "flex",
                        }}
                    >
                        <Divider sx={{ flexGrow: 1, mt: 0, mb: 4 }} orientation="horizontal" />
                    </Box>
                </Grid>
            </Grid>

            <Formik
                initialValues={{
                    Username: "",
                }}
                validationSchema={Yup.object().shape({
                    Username: Yup.string()
                        .trim()
                        .matches(/^(?=.{8,20}$)(?![_.])(?!.*[_.]{2})[a-zA-Z0-9._]+(?<![_.])$/, "Incorrect format")
                        .required("Username is required"),
                })}
                onSubmit={handleSubmit}
            >
                {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values }) => (
                    <form noValidate onSubmit={handleSubmit} {...others}>
                        <FormControl
                            fullWidth
                            error={Boolean(touched.Username && errors.Username)}
                            sx={{ ...theme.typography.h5, mt: 2 }}
                        >
                            <InputLabel htmlFor="outlined-adornment-password-login">Username</InputLabel>
                            <OutlinedInput
                                type="text"
                                value={values.Username}
                                name="Username"
                                onBlur={handleBlur}
                                onChange={handleChange}
                                label="Username"
                                inputProps={{ color: "secondary" }}
                                color="secondary"
                            />
                            {touched.Username && errors.Username && <FormHelperText error>{errors.Username}</FormHelperText>}
                        </FormControl>

                        <Box sx={{ mt: 2 }}>
                            <AnimateButton>
                                <LoadingButton
                                    disableElevation
                                    disabled={isSubmitting}
                                    fullWidth
                                    size="large"
                                    loading={loading}
                                    loadingPosition="start"
                                    type="submit"
                                    variant="contained"
                                    color="secondary"
                                >
                                    Reset Password
                                </LoadingButton>
                            </AnimateButton>
                        </Box>
                    </form>
                )}
            </Formik>
        </>
    );
};

export default ForgotPassword;
